<!-- =========================================================================================
    File Name: DashboardEcommerce.vue
    Description: Dashboard - Ecommerce
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <navigation-side-view
      :isSidebarActive="isNavigationSidebarActive"
      @closeSidebar="toggleDataSidebar"
    />
    <div class="vx-row mt-5 mb-5">
      <div class="vx-col w-1/2" >
        <div class="vx-row">
          <div class="vx-col">
            <h3 class="mr-5">{{ KpiTitle }} </h3>
            <h5 v-if="selectedYear && selectedProject">{{ selectedProject.name }} - {{ selectedYear }} </h5>
            <h5 v-else>{{ $t("ABC.SelectProject") }}</h5>
          </div>
          <div class="vx-col">
            <feather-icon icon="FilterIcon" class="cursor-pointer" svg-classes="h-8 w-8" @click="openFilters" />
          </div>
        </div>
      </div>
      <div class="vx-col w-1/2" >
        <vs-row vs-type="flex" vs-justify="flex-end">
          <vs-col vs-type="flex" vs-justify="flex-end" vs-align="center" vs-w="12">
            <feather-icon icon="NavigationIcon" class="p-4 mb-4 bg-secondary cursor-pointer rounded-full text-white shadow" svg-classes="h-6 w-6"  @click.stop="toggleDataSidebar(true)" />
          </vs-col>
        </vs-row>
      </div>
    </div>
    <div v-if="isFilterDefined">
      <div class="vx-row">
        <div class="vx-col mb-base" :class="upperCss">
          <generic-card-line
          v-if="upper1Data"
          :type="upper1Data.type"
          :analyticsData="upper1Data.analyticsData"
          :zoomInData="upper1Data.zoomIn"
          @onZoomIn="zoomIn"
          @onDrillTo="drillTo"
          :title="upper1Data.name"
          :i18n="upper1Data.i18n"
          :linkTo="upper1Data.linkTo"
          :chartData="upper1Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="upperCss">
          <generic-card-line
            v-if="upper2Data"
            :type="upper2Data.type"
            :analyticsData="upper2Data.analyticsData"
            :zoomInData="upper2Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="upper2Data.name"
            :i18n="upper2Data.i18n"
            :linkTo="upper2Data.linkTo"
            :chartData="upper2Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="upperCss">
          <generic-card-line
            v-if="upper3Data"
            :type="upper3Data.type"
            :analyticsData="upper3Data.analyticsData"
            :zoomInData="upper3Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="upper3Data.name"
            :i18n="upper3Data.i18n"
            :linkTo="upper3Data.linkTo"
            :chartData="upper3Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="upperCss">
          <generic-card-line
            v-if="upper4Data"
            :type="upper4Data.type"
            :analyticsData="upper4Data.analyticsData"
            :zoomInData="upper4Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="upper4Data.name"
            :i18n="upper4Data.i18n"
            :linkTo="upper4Data.linkTo"
            :chartData="upper4Data.chartData" />
        </div>
      </div>
      <div class="vx-row">
        <!-- LINE CHART -->
        <div class="vx-col mb-base" :class="middleCss">
          <generic-card-line
            v-if="middle1Data"
            :type="middle1Data.type"
            :analyticsData="middle1Data.analyticsData"
            :zoomInData="middle1Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="middle1Data.name"
            :i18n="middle1Data.i18n"
            :linkTo="middle1Data.linkTo"
            :chartData="middle1Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="middleCss">
          <generic-card-line
            v-if="middle2Data"
            :type="middle2Data.type"
            :analyticsData="middle2Data.analyticsData"
            :zoomInData="middle2Data.zoomIn"
            @onChildClick="(parent) => { refreshMiddle2(parent);}"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="middle2Data.name"
            :i18n="middle2Data.i18n"
            :linkTo="middle2Data.linkTo"
            :chartData="middle2Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="middleCss">
          <generic-card-line
            v-if="middle3Data"
            :type="middle3Data.type"
            :analyticsData="middle3Data.analyticsData"
            :zoomInData="middle3Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="middle3Data.name"
            :i18n="middle3Data.i18n"
            :linkTo="middle3Data.linkTo"
            :chartData="middle3Data.chartData" />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col mb-base" :class="belowCss">
          <generic-card-line
          v-if="below1Data"
          :type="below1Data.type"
          :analyticsData="below1Data.analyticsData"
          :zoomInData="below1Data.zoomIn"
          @onZoomIn="zoomIn"
          @onDrillTo="drillTo"
          :title="below1Data.name"
          :i18n="below1Data.i18n"
          :linkTo="below1Data.linkTo"
          :chartData="below1Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="belowCss">
          <generic-card-line
            v-if="below2Data"
            :type="below2Data.type"
            :analyticsData="below2Data.analyticsData"
            :zoomInData="below2Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :enableDrill="below2Data.enableDrill"
            :title="below2Data.name"
            :i18n="below2Data.i18n"
            :linkTo="below2Data.linkTo"
            :chartData="below2Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="belowCss">
          <generic-card-line
            v-if="below3Data"
            :type="below3Data.type"
            :analyticsData="below3Data.analyticsData"
            :zoomInData="below3Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="below3Data.name"
            :i18n="below3Data.i18n"
            :linkTo="below3Data.linkTo"
            :chartData="below3Data.chartData" />
        </div>
        <div class="vx-col mb-base" :class="belowCss">
          <generic-card-line
            v-if="below4Data"
            :type="below4Data.type"
            :analyticsData="below4Data.analyticsData"
            :zoomInData="below4Data.zoomIn"
            @onZoomIn="zoomIn"
            @onDrillTo="drillTo"
            :title="below4Data.name"
            :i18n="below4Data.i18n"
            :linkTo="below4Data.linkTo"
            :chartData="below4Data.chartData" />
        </div>
      </div>
    </div>
    <vs-popup class="filterPopup" :title="$t('Filters')" :active.sync="filterPopupActive">
       <vs-row vs-type="flex" style="height:320px;">
        <vs-col vs-type="flex"  class="m-3" >
          <div class="vx-row w-full">
            <div class="vx-col w-1/3" >
              <form-label>{{$t('ABC.Year')}}</form-label>
              <v-select
                label="name"
                :options="years"
                v-model="selectedYear"
                class="w-full"
              />
            </div>
            <div class="vx-col w-1/3" >
              <form-label>{{$t('ABC.Projects')}}</form-label>
              <v-select
                label="name"
                :options="projects"
                v-model="selectedProject"
                class="w-full"
              />
            </div>
            <div class="vx-col w-1/3" >
              <vs-button radius color="primary" type="border" icon-pack="feather" icon="icon-filter" @click="applyFilters"></vs-button>
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-popup>
    <vs-popup class="zoomPopup" :title="$t(zoomInData.i18n) || zoomInData.name" :active.sync="zoomPopupActive">
      <generic-card-line
        :type="zoomInData.type"
        :analyticsData="zoomInData.analyticsData"
        :title="zoomInData.name"
        :i18n="zoomInData.i18n"
        :linkTo="zoomInData.linkTo"
        :chartData="zoomInData.chartData" />
  </vs-popup>
  </div>
</template>

<script>
import analyticsData from './analyticsData.js'
import abcConfig from './abcConfig.js'
import vSelect from 'vue-select';
import GenericCardLine from '@/components/statistics-cards/GenericCardLine.vue'
import { FormLabel } from "./../shared/components";
import navigationSideView from './components/navigationSideView.vue'
import router from '../../router'

export default {
  components: {
    GenericCardLine,
    vSelect,
    FormLabel,
    navigationSideView
  },
  props: {
    kpiId: {
      type: Number
    }
  },
  data () {
    return {
      isNavigationSidebarActive: false,
      pages : abcConfig.pages,
      selectedKpi : null,
      projectId : null,
      title : null,
      i18nTitle : null,
      upperCss : "",
      upper1Data : {},
      upper2Data : {},
      upper3Data : {},
      upper4Data : {},
      middleCss : "",
      middle1Data: {},
      middle2Data: {},
      middle3Data: {},
      middle4Data: {},
      belowCss : "",
      below1Data : {},
      below2Data : {},
      below3Data : {},
      below4Data : {},
      zoomInData: {},
      projects : [
        {
          id : "C011",
          name : "Mine A"
        },
        {
          id : "C030",
          name : "Mine B"
        },
        {
          id : "C051",
          name : "Mine C"
        }
      ],
      years: [
        "FY20",
        "FY21"
      ],
      periods : [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ],
      selectedYear: null,
      selectedProject : null,
      filterPopupActive: false,
      zoomPopupActive: false,
      isFilterDefined: false,
      analyticsData,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    kpiId(val) {
      if (val) {
        const kpiId = parseInt(val);
        this.refreshPage(kpiId);
      }
    }
  },
  computed: {
    scrollbarTag () { 
      return this.$store.getters.scrollbarTag 
    },
    KpiTitle() {
      if (this.i18nTitle) { 
        return this.$t(this.i18nTitle);

      } else {
        return this.title;
      }
    }
  },
  created () {
    const kpiId = parseInt(this.kpiId);
    
    if (!this.isFilterDefined) {
      this.selectedProject = this.projects[0];
      this.selectedYear = this.years[this.years.length - 1];
      this.isFilterDefined = true;
    }

    this.refreshPage(kpiId);
  },
  methods : {
    toggleDataSidebar(val = false) {
      this.isNavigationSidebarActive = val;
    },
    zoomIn(zoomInData) {
      this.$vs.loading();
      this.fetchData(zoomInData)
        .then((response) => { 
          this.zoomPopupActive = true;
          this.zoomInData = response;
          this.$vs.loading.close();
        });
    },
    drillTo(linkTo) {
      router.push({ path: linkTo })
    },
    openFilters() {
      this.filterPopupActive = true;
      this.isFilterDefined = false;
    },
    applyFilters() {
      this.filterPopupActive = false;
      this.isFilterDefined = this.selectedYear && this.selectedProject;
      this.refreshVisuals();
    },
    refreshPage (kpiId) {
      this.selectedKpi = this.pages.find(p => p.id === kpiId);
      this.title = this.selectedKpi.title;
      this.i18nTitle = this.selectedKpi.i18n;
      if (this.selectedKpi.layout.upper4) {
        this.upperCss = 'w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4';
      } else if (this.selectedKpi.layout.upper3) {
        this.upperCss = 'w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3';
      } else {
        this.upperCss = 'w-full lg:w-1/2 xl:w-1/2';
      }

      if (this.selectedKpi.layout.middle3) {
        this.middleCss = 'w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3';
      } else {
        this.middleCss = 'w-full lg:w-1/2 xl:w-1/2';
      }

      if (this.selectedKpi.layout.below4) {
        this.belowCss = 'w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4';
      } else if (this.selectedKpi.layout.below3) {
        this.belowCss = 'w-full sm:w-1/2 md:w-1/2 lg:w-1/3 xl:w-1/3';
      } else {
        this.belowCss = 'w-full lg:w-1/2 xl:w-1/2';
      }

      this.refreshVisuals();
    },
    fetchData(kpi, parent = "") {
      if (kpi.muck) 
        return this.fetchDataMuck(kpi, parent);
      else
        return this.fetchWebData(kpi, parent);
    },
    fetchWebData(kpi, parent) {
      return new Promise((resolve, reject) => {
        this.$webApi.get(kpi.url, {
          params: {
            entity: this.selectedProject.id,
            year: this.selectedYear,
            parent
          }
        }).then((response) => {
          const data = {
            name: kpi.name,
            i18n : kpi.i18n,
            type: kpi.type,
            zoomIn : kpi.zoomIn,
            linkTo : kpi.drillTo,
            analyticsData : response.data,
            chartData : kpi.chartData
          };
          resolve(data) })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: this.$t("LoadingError"),
              text: error.message  
            })
            reject(error);
          })
      })
    },
    fetchDataMuck(kpi, parent) {
      return new Promise((resolve, reject) => {
        this.$http.get(kpi.url, {
          params: {
            entity: this.selectedProject.id,
            year: this.selectedYear,
            parent
          }
        }).then((response) => {
          const data = {
            name: kpi.name,
            i18n : kpi.i18n,
            type: kpi.type,
            zoomIn : kpi.zoomIn,
            linkTo : kpi.drillTo,
            analyticsData : response.data.analyticsData,
            chartData : kpi.chartData
          };
          resolve(data) })
          .catch((error) => {
            this.$vs.notify({
              color: "danger",
              title: this.$t("LoadingError"),
              text: error.message  
            })
            reject(error);
          })
      })
    },

    refreshUpper1() {
      return new Promise((resolve, reject) => {
        this.fetchData(this.selectedKpi.layout.upper1)
          .then((response) => { 
            this.upper1Data = response;
            resolve() })
          .catch((error) => {
            this.upper1Data = null;
            reject(error);
          })
      })
    },
    refreshUpper2() {
      return new Promise((resolve, reject) => {
        this.fetchData(this.selectedKpi.layout.upper2)
          .then((response) => { 
            this.upper2Data = response;
            resolve() })
          .catch((error) => {
            this.upper2Data = null;
            reject(error);
          })
      })
    },
    refreshUpper3() {
      return new Promise((resolve, reject) => {
        this.fetchData(this.selectedKpi.layout.upper3)
          .then((response) => { 
            this.upper3Data = response;
            resolve() })
          .catch((error) => {
            this.upper3Data = null;
            reject(error);
          })
      })
    },
    refreshUpper4() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.upper4) {
          this.fetchData(this.selectedKpi.layout.upper4)
            .then((response) => { 
              this.upper4Data = response;
              resolve() })
            .catch((error) => {
              this.upper4Data = null;
              reject(error);
            })
        }
        else {
          this.upper4Data = null;
          resolve();
        }
      })
    },
    refreshMiddle1() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.middle1) {
          this.fetchData(this.selectedKpi.layout.middle1)
            .then((response) => { 
              this.middle1Data = response;
              resolve() })
            .catch((error) => {
              this.middle1Data = null;
              reject(error);
            })
        } 
        else {
          this.middle1Data = null;
          resolve();
        }
      })
    },
    refreshMiddle2(parent = "") {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.middle2) {
          this.fetchData(this.selectedKpi.layout.middle2, parent)
            .then((response) => { 
              this.middle2Data = response;
              resolve() })
            .catch((error) => {
              this.middle2Data = null;
              reject(error);
            })
        } 
        else {
          this.middle2Data = null;
          resolve();
        }
      })
    },
    refreshMiddle3() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.middle3) {
          this.fetchData(this.selectedKpi.layout.middle3)
            .then((response) => { 
              this.middle3Data = response;
              resolve() })
            .catch((error) => {
              this.middle3Data = null;
              reject(error);
            })
        } 
        else {
          this.middle3Data = null;
          resolve();
        }
      })
    },
    refreshBelow1() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.below1) {
          this.fetchData(this.selectedKpi.layout.below1)
            .then((response) => {
              this.below1Data = response;
              resolve() })
            .catch((error) => {
              this.below1Data = null;
              reject(error);
            })
        } 
        else {
          this.below1Data = null;
          resolve();
        }
      })
    },
    refreshBelow2() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.below2) {
          this.fetchData(this.selectedKpi.layout.below2)
            .then((response) => { 
              this.below2Data = response;
              resolve() })
            .catch((error) => {
              this.below2Data = null;
              reject(error);
            })
        } 
        else {
          this.below2Data = null;
          resolve();
        }
      })
    },
    refreshBelow3() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.below3) {
          this.fetchData(this.selectedKpi.layout.below3)
            .then((response) => { 
              this.below3Data = response;
              resolve() })
            .catch((error) => {
              this.below3Data = null;
              reject(error);
            })
        } 
        else {
          this.below3Data = null;
          resolve();
        }
      })
    },
    refreshBelow4() {
      return new Promise((resolve, reject) => {
        if (this.selectedKpi.layout.below4) {
          this.fetchData(this.selectedKpi.layout.below4)
            .then((response) => { 
              this.below4Data = response;
              resolve() })
            .catch((error) => {
              this.below4Data = null;
              reject(error);
            })
        } 
        else {
          this.below4Data = null;
          resolve();
        }
      })
    },

    refreshVisuals() {
      if (this.isFilterDefined) {
        this.$vs.loading();
        Promise.all([
          this.refreshUpper1(),
          this.refreshUpper2(),
          this.refreshUpper3(),
          this.refreshUpper4(),
          this.refreshMiddle1(),
          this.refreshMiddle2(),
          this.refreshMiddle3(),
          this.refreshBelow1(),
          this.refreshBelow2(),
          this.refreshBelow3(),
          this.refreshBelow4()
        ]).finally(() => {
          this.$vs.loading.close();
        })
      }
    }
  }
}
</script>

<style lang="scss">
  .zoomPopup {
    .vs-popup {
      width: 1200px !important;
    }
  } 
  .filterPopup {
    .vs-popup {
      width: 600px !important;
    }
  }
</style>
